import {
  buildWhatsAppUrl, whatsappMessage, formatRupees,
  type HomepageConfig, type PrepaidPackage, type SiteSettings,
} from '@cng/shared';

interface PrepaidPackagesProps {
  config: HomepageConfig['packages'];
  items: PrepaidPackage[];
  settings: SiteSettings;
}

export function PrepaidPackages({ config, items, settings }: PrepaidPackagesProps) {
  if (!config?.enabled || items.length === 0) return null;

  const phone = settings.whatsappNumber || settings.primaryPhone;

  return (
    <div className="theme-wrapper">
      <div className="theme-header">
        <h2>
          {config.title}
          {config.titleAccent ? <> <span>{config.titleAccent}</span></> : null}
        </h2>
      </div>

      <div className="theme-grid">
        {items.map((pkg, index) => {
          // The original cards carry no CTA. One appears only when the owner sets a
          // WhatsApp message for that package in admin, so the default matches the live site.
          const message = pkg.whatsappMessage
            ? whatsappMessage('packageEnquiry', { name: pkg.name }, {
              ...settings.whatsappTemplates,
              packageEnquiry: pkg.whatsappMessage,
            })
            : '';
          return (
            <article className="theme-card" key={pkg._id}>
              <div className="package-strip" aria-hidden="true">
                <span className="pkg-label">{pkg.packageLabel || 'Package'}</span>
                <span className="pkg-num">{pkg.packageNumber || String(index + 1).padStart(2, '0')}</span>
              </div>

              <div className="package-art" aria-hidden="true">
                <span className="package-art-mark">C&amp;G</span>
                <span>Salon credit</span>
              </div>

              <div className="card-content">
                <div className="card-title-group">
                  {pkg.badge ? <span className="card-subtitle">{pkg.badge}</span> : null}
                  <h3>{pkg.name}</h3>
                  <div className="dotted-line" aria-hidden="true" />
                </div>

                <div>
                  <div className="price-row-theme">
                    <span className="p-label">{pkg.payLabel || 'You Pay'}</span>
                    <span className="p-value">{formatRupees(pkg.payAmount)}</span>
                  </div>
                  <div className="price-row-theme">
                    <span className="p-label">{pkg.valueLabel || 'Get Value'}</span>
                    <span className="p-value p-value-large">{formatRupees(pkg.valueAmount)}</span>
                  </div>
                  {pkg.terms ? <div className="tnc-text">{pkg.terms}</div> : null}
                  {message ? (
                    <a
                      className="pkg-enquire"
                      href={buildWhatsAppUrl({ phone, message })}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Enquire about the ${pkg.name} package on WhatsApp`}
                    >
                      Enquire on WhatsApp
                    </a>
                  ) : null}
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}
